import {invalidateAccounts} from 'modules/store/accounts';
import {invalidateSecurityCredentials} from 'modules/store/securityCredentials';

const _getInitialState = () => ({
});

export const invalidateMyAccounts = () => dispatch => {
    dispatch(invalidateAccounts());
    dispatch(invalidateSecurityCredentials());
};

export const reducer = (state = _getInitialState(), action = {}) => {
    switch (action.type) {
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/userAccounts.js